var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "d-flex flex-column screen-control-planning-table__intervention-material-cell",
    },
    [
      _c(
        "div",
        {
          staticClass:
            "screen-control-planning-table__body-cell--intervention-material--intervention",
        },
        [
          _c("kh-text", {
            directives: [
              {
                name: "kh-animation",
                rawName: "v-kh-animation",
                value: _vm.animationIntervention,
                expression: "animationIntervention",
              },
            ],
            staticClass: "ma-0",
            attrs: { text: _vm.intervention },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "screen-control-planning-table__body-cell--intervention-material--material",
        },
        [
          _c("kh-text", {
            directives: [
              {
                name: "kh-animation",
                rawName: "v-kh-animation",
                value: _vm.animationMaterial,
                expression: "animationMaterial",
              },
            ],
            staticClass: "ma-0",
            attrs: { text: _vm.interventionMaterialAndRemark },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }